<template>
  <TagModal
    v-if="ctx.movieSearch.showTagModal"
    title="動画タグの選択"
    v-model="ctx.movieSearch.params.tags"
    :allow-create-tag="false"
    @close="ctx.onTagParamChange()"
    @dismiss="ctx.movieSearch.showTagModal = false"
  />
</template>

<script setup lang="ts">
import { useMovieSearchStore } from 'src/composables/useMovieSearch';

const ctx = useMovieSearchStore();
</script>
